import { render } from "./Guidelines.vue?vue&type=template&id=8325090a"
import script from "./Guidelines.vue?vue&type=script&lang=js"
export * from "./Guidelines.vue?vue&type=script&lang=js"

import "./Guidelines.vue?vue&type=style&index=0&id=8325090a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__